import React from 'react'


export default function Penthouses() {
console.log('x')


 return (
   <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
     <iframe
       src="/dist/index.html"
       title="Vite App"
       style={{
         width: '100%',
         height: '100%',
         border: 'none',
         overflow: 'hidden'
       }}
       allow="accelerometer; camera; geolocation; microphone; autoplay"
     />
   </div>
 )
}




